import React from "react"
import { HourPickerSeeker } from "@ui-seeker/core"

import { endHour } from "@signals"

export default function EndHourPicker({ ...props }) {

	return <HourPickerSeeker
		hideMinutes={minutes => minutes % 30 !== 0}
		value={endHour.value}
		onChange={e => endHour.value = e}
		label="Dropoff time"
		{...props}
	/>
}